module.exports = __webpack_public_path__ + "media/styleguide/icons/pro-star-09af9989573faf7b87d4e41e185587ea.svg";